import React, { useEffect, useCallback } from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Button,
  Typography,
  Chip,
  Divider,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { StyledPaper, StyledCarousel } from "../StyledMui";
import useStore from "../Store";

function Preview() {
  const {
    isVar,
    setIsVar,
    page,
    setPage,
    phoneMessageSwitchFlag,
    loading,
    error,
    success,
    selectedTemplate,
    setSelectedTemplate,
    selectedChannelName,
    contacts,
    getContacts,
    datas,
    executeV2,
    noContentFiles,
    fetchNoContentFiles,
    actId,
    queryMappingTable,
    setSelectedChannelName,
  } = useStore((state) => ({
    ...state.preview,
    ...state.header,
    ...state.mapper,
  }));

  // actId가 있을 경우 매핑 테이블 조회 후 selectedChannelName과 selectedTemplate 업데이트
  useEffect(() => {
    const updateMapping = async () => {
      console.log("actId:", actId);
      if (!actId) return;
      try {
        const data = await queryMappingTable(actId);
        console.log("Mapping data:", data);
        // check if inArguments is an array before calling forEach
        if (Array.isArray(data[0])) {
          parsedMapping.forEach((item) => {
            console.log('item:', item);
            
            if (item.name === "selectedChannelName") {
              console.log("selectedChannelName:", item.value);
              // 분리해서 state에 설정
              setSelectedChannelName(item.value); // channelName만 설정
            }
            if (item.name === "selectedTemplate") {
              console.log("selectedTemplate:", item.value);
              setSelectedTemplate(item.value);
            }
          });
        }
      } catch (err) {
        console.error("Mapping update error:", err);
      } finally {
        console.log("Mapping update finished");
      }
    };
    updateMapping();
  }, [actId, queryMappingTable, setSelectedChannelName, setSelectedTemplate]);
  
  // selectedTemplate의 msg_no가 변경될 때 noContentFiles 업데이트
  useEffect(() => {
    if (selectedTemplate?.msg_no) {
      fetchNoContentFiles(selectedTemplate.msg_no);
    }
  }, [selectedTemplate?.msg_no, fetchNoContentFiles]);

  const handleVariabled = async (sw, isPhoneMessage) => {
    setIsVar(sw);
    if (sw && contacts.length === 0) {
      await getContacts();
    } else {
      setPage(0);
    }
  };

  const setVariables = (contact, isPhoneMessage, text) => {
    let result =
      isPhoneMessage && selectedTemplate.mmsAttach
        ? JSON.parse(selectedTemplate.mmsAttach)?.mmsContent || ""
        : text;

    if (contact && text) {
      const matches = text.match(/(?<=#\{)(.*?)(?=\})/g);
      if (matches) {
        matches.forEach((variable) => {
          datas
            .filter((d) => d.name === variable)
            .forEach((el) => {
              let replacement;
              if (el.type === "field") {
                if (el.value === "Contact Name") {
                  replacement =
                    contact["contact last name"] +
                    contact["contact first name"];
                } else if (el.value === "SalesRep Name") {
                  replacement =
                    contact["salesrep last name"] +
                    contact["salesrep first name"];
                } else if (el.value === "Name") {
                  replacement = contact["last name"] + contact["first name"];
                } else {
                  replacement = contact[el.value.toLowerCase()];
                }
              } else {
                replacement = el.value;
              }
              result = result.replaceAll(`#{${el.name}}`, replacement);
            });
        });
      }
    }
    return result;
  };

  const useHighlightedContent = (content, variabled) => {
    return content?.split(/(#{.*?})/g).map((part, index) => {
      if (part.startsWith("#{") && part.endsWith("}")) {
        return (
          <span style={{ backgroundColor: "yellow" }} key={index}>
            {variabled ? part.replace(/[#\{\}]/g, "") : part}
          </span>
        );
      }
      return part;
    });
  };

  const channelHosts = {
    OBU: "https://novo-obu.s3.ap-northeast-2.amazonaws.com/",
    RBU: "https://novo-rbu.s3.ap-northeast-2.amazonaws.com/",
    DBU: "https://novo-dbu.s3.ap-northeast-2.amazonaws.com/",
  };
  const host = channelHosts[selectedChannelName] || "";

  const renderNoContentFiles = useCallback(() => {
    return noContentFiles.map((file, index) => (
      <Button
        key={index}
        variant="contained"
        fullWidth
        sx={{
          backgroundColor: "#6c757d",
          "&:hover": { backgroundColor: "#343a40" },
          marginTop: "20px",
        }}
        onClick={() => window.open(file.btn_url, "_blank")}
      >
        {file.btn_name}
      </Button>
    ));
  }, [noContentFiles]);

  const renderTemplateContent = () => {
    if (!phoneMessageSwitchFlag && selectedTemplate.templateMessageType === "FC") {
      const carouselItems = [...Array(6).keys()]
        .filter((index) => selectedTemplate[`carouselHeader${index + 1}`] != null)
        .map((index) => {
          const headerKey = `carouselHeader${index + 1}`;
          const messageKey = `carouselMessage${index + 1}`;
          const imageUrl =
            selectedTemplate.templateImageUrl &&
            JSON.parse(selectedTemplate.templateImageUrl)[index];
          const buttons =
            selectedTemplate.buttons &&
            JSON.parse(selectedTemplate.buttons)[index];
          return (
            <React.Fragment key={index}>
              {imageUrl && (
                <CardMedia
                  component="img"
                  height="auto"
                  image={imageUrl}
                  alt={`Carousel Image ${index + 1}`}
                />
              )}
              <Stack direction="column" spacing={1}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ margin: "10px !important", textAlign: "left" }}
                >
                  {useHighlightedContent(
                    isVar
                      ? setVariables(
                          contacts[page],
                          phoneMessageSwitchFlag,
                          selectedTemplate[headerKey]
                        )
                      : selectedTemplate[headerKey],
                    isVar
                  )}
                </Typography>
                <Divider sx={{ marginX: "15px" }} />
                <Typography
                  variant="body2"
                  sx={{ textAlign: "left", margin: "10px !important" }}
                >
                  {useHighlightedContent(
                    isVar
                      ? setVariables(
                          contacts[page],
                          phoneMessageSwitchFlag,
                          selectedTemplate[messageKey]
                        )
                      : selectedTemplate[messageKey],
                    isVar
                  )}
                </Typography>
                {buttons && (
                  <Stack
                    direction="row"
                    spacing={0.5}
                    alignItems="center"
                    sx={{ margin: "8px !important", justifyContent: "center" }}
                  >
                    {buttons.map((button, btnIndex) => (
                      <Button
                        key={btnIndex}
                        variant="contained"
                        fullWidth
                        sx={{
                          backgroundColor: "#6c757d",
                          "&:hover": { backgroundColor: "#343a40" },
                        }}
                        onClick={() =>
                          window.open(button.btn_url || button.url, "_blank")
                        }
                      >
                        {button.btn_name || button.name}
                      </Button>
                    ))}
                  </Stack>
                )}
              </Stack>
            </React.Fragment>
          );
        });
      return (
        <StyledCarousel
          swipeable
          showThumbs={false}
          dynamicHeight={false}
          showStatus={false}
        >
          {carouselItems}
        </StyledCarousel>
      );
    }
    if (!phoneMessageSwitchFlag && selectedTemplate.templateMessageType === "FL") {
      return (
        <CardContent>
          <Typography
            variant="body1"
            sx={{ fontWeight: "bold", margin: "10px", textAlign: "center" }}
          >
            {useHighlightedContent(
              isVar
                ? setVariables(
                    contacts[page],
                    phoneMessageSwitchFlag,
                    selectedTemplate.itemListHeader
                  )
                : selectedTemplate.itemListHeader,
              isVar
            )}
          </Typography>
          <Box
            sx={{
              position: "relative",
              maxWidth: 300,
              height: 120,
              margin: "auto",
              display: "block",
            }}
          >
            <CardMedia
              component="img"
              sx={{ width: "100%", height: "100%" }}
              image={
                selectedTemplate.templateImageUrl &&
                JSON.parse(selectedTemplate.templateImageUrl)[0]
              }
              alt="Item List Image 1"
            />
            <Typography
              variant="body2"
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                color: "white",
                padding: "2px",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              }}
            >
              {useHighlightedContent(
                isVar
                  ? setVariables(
                      contacts[page],
                      phoneMessageSwitchFlag,
                      selectedTemplate.itemListTitle1
                    )
                  : selectedTemplate.itemListTitle1,
                isVar
              )}
            </Typography>
          </Box>
          <Stack direction="column" spacing={1}>
            {[1, 2, 3, 4].map((num) => {
              const titleKey = `itemListTitle${num}`;
              const imageKey = num - 1;
              if (!selectedTemplate[titleKey]) return null;
              return (
                <Grid container spacing={1} alignItems="center" key={num}>
                  <Grid item xs={2}>
                    <CardMedia
                      component="img"
                      height="60"
                      image={
                        selectedTemplate.templateImageUrl &&
                        JSON.parse(selectedTemplate.templateImageUrl)[imageKey]
                      }
                      alt={`Item List Image ${num}`}
                    />
                  </Grid>
                  <Grid item xs={10}>
                    <Typography variant="body2">
                      {useHighlightedContent(
                        isVar
                          ? setVariables(
                              contacts[page],
                              phoneMessageSwitchFlag,
                              selectedTemplate[titleKey]
                            )
                          : selectedTemplate[titleKey],
                        isVar
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}
          </Stack>
        </CardContent>
      );
    }
    return (
      <>
        {selectedTemplate.msg_img_url && (
          <CardMedia
            component="img"
            height="auto"
            image={selectedTemplate.msg_img_url}
            alt="Thumbnail"
          />
        )}
        <CardContent>
          {phoneMessageSwitchFlag && selectedTemplate.mmsAttach && (
            <Typography
              variant="h6"
              color="text.secondary"
              sx={{
                textAlign: "left",
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
                fontWeight: "bold",
              }}
            >
              {JSON.parse(selectedTemplate.mmsAttach).subject}
            </Typography>
          )}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              textAlign: "left",
              wordWrap: "break-word",
              whiteSpace: "pre-wrap",
            }}
          >
            {useHighlightedContent(
              isVar
                ? setVariables(
                    contacts[page],
                    phoneMessageSwitchFlag,
                    selectedTemplate.msg_desc
                  )
                : selectedTemplate.msg_desc,
              isVar
            )}
          </Typography>
          {!phoneMessageSwitchFlag &&
            (selectedTemplate.templateMessageType === "EX" ||
              selectedTemplate.templateMessageType === "MI") && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  textAlign: "left",
                  marginTop: "10px",
                  fontSize: "12px",
                  wordWrap: "break-word",
                  whiteSpace: "pre-wrap",
                }}
              >
                {selectedTemplate.templateExtra}
              </Typography>
            )}
        </CardContent>
      </>
    );
  };

  const renderButtons = () => {
    if (phoneMessageSwitchFlag || selectedTemplate.templateMessageType === "FC")
      return null;
    const parsedButtons =
      selectedTemplate.buttons && JSON.parse(selectedTemplate.buttons)[0];
    return (
      <Stack spacing={0.5} sx={{ margin: "10px" }}>
        {selectedTemplate.templateMessageType === "FL" ? (
          <Stack direction="row" spacing={0.5} alignItems="center">
            {parsedButtons &&
              parsedButtons.map((button, index) => (
                <Button
                  key={index}
                  variant="contained"
                  fullWidth
                  sx={{
                    backgroundColor: "#6c757d",
                    "&:hover": { backgroundColor: "#343a40" },
                  }}
                  onClick={() =>
                    window.open(button.btn_url || button.url, "_blank")
                  }
                >
                  {button.btn_name || button.name}
                </Button>
              ))}
          </Stack>
        ) : (
          parsedButtons &&
          parsedButtons.map((button, index) => (
            <Button
              key={index}
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: "#6c757d",
                "&:hover": { backgroundColor: "#343a40" },
              }}
              onClick={() =>
                window.open(button.btn_url || button.url, "_blank")
              }
            >
              {button.btn_name || button.name}
            </Button>
          ))
        )}
      </Stack>
    );
  };

  const renderQuickReplies = () => {
    if (phoneMessageSwitchFlag || !selectedTemplate.quickReplies) return null;
    const quickReplies = JSON.parse(selectedTemplate.quickReplies);
    return (
      <Box sx={{ maxWidth: 350, display: "flex", flexWrap: "nowrap" }}>
        <Stack spacing={0.5} sx={{ marginTop: "10px" }} direction="row">
          {quickReplies.map((quickLink, index) => (
            <Chip
              key={index}
              label={quickLink.name}
              sx={{
                backgroundColor: "#f1f1f1",
                color: "#191919",
                whiteSpace: "nowrap",
                minWidth: "0",
                "&:hover": { backgroundColor: "#cccccc" },
              }}
            />
          ))}
        </Stack>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
        marginX: "50px",
      }}
    >
      <Card sx={{ maxWidth: 350, width: "100%" }}>
        {renderTemplateContent()}
        {renderButtons()}
      </Card>
      <Box sx={{ marginTop: "20px" }}>
        {!selectedTemplate ? (
          <Typography variant="body2">콘텐츠를 먼저 선택해주세요</Typography>
        ) : Array.isArray(noContentFiles) && noContentFiles.length > 0 ? (
          <TableContainer component={StyledPaper}>
            <Table>
              <TableHead>
                <TableRow>{/* 필요한 경우 헤더 추가 */}</TableRow>
              </TableHead>
              <TableBody>{renderNoContentFiles()}</TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography variant="body2" />
        )}
      </Box>
      <Box sx={{ marginTop: "20px" }}>
        {success && (
          <Typography
            variant="body1"
            color="success.main"
            sx={{ marginTop: "10px" }}
          >
            API 호출이 성공적으로 완료되었습니다.
          </Typography>
        )}
        {error && (
          <Typography variant="body1" color="error.main" sx={{ marginTop: "10px" }}>
            {error}
          </Typography>
        )}
        {loading && (
          <Typography variant="body1" color="text.secondary" sx={{ marginTop: "10px" }}>
            API 호출 중...
          </Typography>
        )}
      </Box>
      {/* <Button
        variant="contained"
        fullWidth
        sx={{
          backgroundColor: "#6c757d",
          "&:hover": { backgroundColor: "#343a40" },
          marginTop: "20px",
        }}
        onClick={executeV2}
        disabled={loading}
      >
        {loading ? "실행 중..." : "친구톡 API 호출하기"}
      </Button> */}
      {renderQuickReplies()}
    </Box>
  );
}

export default Preview;
